import { Box, Skeleton } from "@mui/material";
import React from "react";

const VariableSearchDialogSkeleton: React.FC = () => {
  return (
    <Box mb={2}>
      <Skeleton variant="text" width={150} height={40} sx={{ mb: 2 }} />
      {[1, 2].map((categoryIndex) => (
        <Box key={categoryIndex} mb={2}>
          <Skeleton variant="text" width={200} height={30} sx={{ mb: 1 }} />
          <Box
            sx={{
              display: "flex",
              flexWrap: "wrap",
              gap: 1,
            }}
          >
            {[1, 2, 3, 4].map((chipIndex) => (
              <Skeleton
                key={chipIndex}
                variant="rounded"
                width={120}
                height={32}
              />
            ))}
          </Box>
        </Box>
      ))}
    </Box>
  );
};

export default VariableSearchDialogSkeleton;
